// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__uumQ6","head":"Table_head__3nF_U","col":"Table_col__2kdk8"};